import FetchHelper from '~/utils/fetch-helper/fetch-helper';
import fetchWrapper from '~/utils/fetch-wrapper/fetch-wrapper';

export default abstract class API {
  protected readonly endpoint: string;
  protected readonly fetchHelper: typeof FetchHelper = FetchHelper;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  protected fetch<T = Record<string, any>>(request: Request) {
    return fetchWrapper<T>(request);
  }
}
